import { LOCALES, SITE_HOST } from './constants';

export const getLanguageCode = ({ code }) => code.split('-')[0];

const isProductionHost = (host) =>
  host === SITE_HOST || host.endsWith(`.${SITE_HOST}`);

const byLanguageCode = (code) =>
  LOCALES.find((locale) => getLanguageCode(locale) === code);

/**
 * Picks the locale for this page load. On a language subdomain that wins;
 * elsewhere a `?lang=` parameter, then the browser language. On the apex or
 * www host of the production domain the browser is sent to the matching
 * language subdomain (Vercel does the same server-side, this covers cached
 * or odd requests). Preview and local hosts are never redirected, which is
 * why they carry the language in the query instead.
 */
export const resolveLocale = () => {
  const { host, hostname, pathname, search, hash, protocol } = window.location;
  const [subdomain] = hostname.split('.');

  const subdomainLocale = byLanguageCode(subdomain);
  const queryLocale = byLanguageCode(new URLSearchParams(search).get('lang'));
  const [navigatorLanguage] = (window.navigator.language || '').split('-');
  const navigatorLocale = byLanguageCode(navigatorLanguage);
  const defaultLocale = LOCALES.find((locale) => locale.default);
  const locale =
    subdomainLocale || queryLocale || navigatorLocale || defaultLocale;

  let redirectTo = null;
  if (!subdomainLocale && isProductionHost(host)) {
    redirectTo = `${protocol}//${getLanguageCode(locale)}.${SITE_HOST}${pathname}${search}${hash}`;
  }

  return { locale, redirectTo };
};

/**
 * The same page in another language: swaps the language subdomain when the
 * URL has one, otherwise sets `?lang=`.
 */
export const localizeUrl = (url, fromLocale, toLocale) => {
  const from = getLanguageCode(fromLocale);
  const to = getLanguageCode(toLocale);
  const subdomain = new RegExp(`^(https?:\\/\\/)${from}\\.`);
  if (subdomain.test(url)) return url.replace(subdomain, `$1${to}.`);
  const target = new URL(url, window.location.href);
  target.searchParams.set('lang', to);
  return target.toString();
};

export const nextLocale = (locale) => {
  const index = LOCALES.findIndex(({ code }) => code === locale.code);
  return LOCALES[(index + 1) % LOCALES.length];
};
